/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuswertungUnteraufgabenListe } from '../models/AuswertungUnteraufgabenListe';
import type { UnteraufgabenPromptItem } from '../models/UnteraufgabenPromptItem';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuswertungUnteraufgabeService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Auswertung einer Unteraufgabe für eine Kontaktaufnahme
   * Gibt die Auswertung einer Unteraufgabe für eine bestimmte Kontaktaufnahme zurück
   * @returns AuswertungUnteraufgabenListe Alle Unteraufgabenauswertung der Aufgabenauswertung
   * @throws ApiError
   */
  public getAuswertungUnteraufgabe({
    auswertungAufgabeId,
  }: {
    /**
     * ID der Auswertung der Aufgabe
     */
    auswertungAufgabeId: string,
  }): CancelablePromise<AuswertungUnteraufgabenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/auswertung/unteraufgabe/{auswertungAufgabeId}',
      path: {
        'auswertungAufgabeId': auswertungAufgabeId,
      },
      errors: {
        400: `Bad Request for this request`,
        401: `Unauthorized for this request`,
        403: `Forbidden for this request`,
        404: `Not Found for this request`,
      },
    });
  }

  /**
   * Prompt der Unteraufgabe mit KontaktePromptInserts
   * Gibt den Prompt der Unteraufgabe mit den zugehörigen KontaktePromptInserts zurück
   * @returns UnteraufgabenPromptItem Unteraufgabe mit ersetztem Prompt
   * @throws ApiError
   */
  public getUnteraufgabePromptWithInserts({
    unteraufgabeId,
    kontaktId,
    aufgabeId,
  }: {
    /**
     * ID der Unteraufgabe
     */
    unteraufgabeId: string,
    /**
     * ID des Kontakts
     */
    kontaktId: string,
    /**
     * ID der Aufgabe
     */
    aufgabeId: string,
  }): CancelablePromise<UnteraufgabenPromptItem> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/auswertung/unteraufgabe/{unteraufgabeId}/prompt-with-inserts/{kontaktId}/{aufgabeId}',
      path: {
        'unteraufgabeId': unteraufgabeId,
        'kontaktId': kontaktId,
        'aufgabeId': aufgabeId,
      },
      errors: {
        400: `Bad Request for this request`,
        401: `Unauthorized for this request`,
        403: `Forbidden for this request`,
        404: `Not Found for this request`,
      },
    });
  }

}
